import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NewRequest } from '../../shared/models/request/new-request/new-request';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NotificationService } from '../../core/services/notification.service';
import { AppService } from '../../app.service';
import { ComponentPageBase } from '../../shared/components/component-page-base/component-page-base';
import { NewRequestsService } from '../../shared/services/new-requests.service';
import { KeyValueObject } from '../../shared/models/core/KeyValueObject';
import { EntityViewModel } from '../../shared/models/core/EntityViewModel';
import { CustomerObjectsService } from '../../categories/customer-objects/customer-objects.service';
import { DialogService } from '@progress/kendo-angular-dialog'; import { ContragentWithContactDto } from '../../shared/models/contragent/contragent-with-contact-dto';
import { CustomerObjectWithContactsDto } from '../../shared/models/customerObject/customer-object-with-contacts.dto';
import { NewRequestCustomerObjectInfoComponent } from './sub-components/customer-object-info/new-request-customer-object-info.component';
import { NewRequestServicesAndDevicesComponent } from './sub-components/services-and-devices/new-request-services-and-devices.component';
import { NewRequestService } from '../../shared/models/request/new-request/new-request-service';
import { NewRequestDevice } from '../../shared/models/request/new-request/new-request-device';
import { RequestType } from '../../shared/enums';
import { CustomerObjectDeviceDto } from '../../shared/models/customerObject/customer-object-device';
import { NewRequestRelatedRequestsComponent } from './sub-components/related-requests/new-request-related-requests.component';
import { MenuItemState, NewRequestMenuComponent } from './sub-components/menu/new-request-menu.component';
import { filter } from 'rxjs/operators';
import { NewRequestMenuItemsEnum } from './sub-components/menu/new-request-menu-items.enum';
import { isError } from 'util';
import { NewRequestClientInfoComponent } from './sub-components/client-info/new-request-client-info.component';
import { ContragentsService } from '../../categories/contragents/contragents.service';
import { LeadsService } from '../../shared/services/leads.service';
import { DaDataService } from '../../shared/services/dadata.service';
import { LeadDetails } from '../../shared/models/lead/lead-details';
import { RequestsService } from '../../shared/services/requests.service';
import { RequestBwt } from '../../shared/models/request/request-bwt';

@Component({
	selector: 'new-request-page',
	templateUrl: './new-request.page.html',
	styleUrls: [
		'./new-request.page.scss',
		'../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
	]
})
export class NewRequestPage extends ComponentPageBase<NewRequest> implements OnInit {
	private readonly leadUpdatedStorageEventKey = 'lead-updated-event';

	@ViewChild('clientInfo') clientInfoComponent: NewRequestClientInfoComponent;
	@ViewChild("customerObjectInfo") customerObjectInfoBlock: NewRequestCustomerObjectInfoComponent;
	@ViewChild("serviceAndDevices") servicesAndDevicesBlock: NewRequestServicesAndDevicesComponent;
	@ViewChild("relatedRequestsComponent") relatedRequestsBlock: NewRequestRelatedRequestsComponent;
	@ViewChild("menuComponent") menuComponent: NewRequestMenuComponent;

	customerObjects: KeyValueObject[] = [];
	customerObjectDevices: CustomerObjectDeviceDto[] = [];

	selectedCustomerObject: CustomerObjectWithContactsDto = { contacts: [] } as CustomerObjectWithContactsDto;

	/** Ид лида из query (?leadId=), для тела запроса при сохранении. */
	leadContextId: number = null;

	/** Ид родительской заявки из query (?parentRequestId=) — создание дочерней (Сервис/Монтаж). */
	parentContextId: number = null;

	/** Объект родителя, который нужно выбрать в дропдауне после загрузки списка объектов клиента. */
	private pendingCustomerObjectId: number = null;

	/** Данные лида загружены — можно монтировать блок общей информации. */
	leadDetailsLoaded = false;

	/** Предзаполнение формы нового клиента из лида. */
	leadNewClientPrefill: Partial<ContragentWithContactDto> = null;

	/** Предзаполнение InitType с лида (для beforeSaveChanges). */
	leadPrefillInitTypeId: number = null;

	/** InitTypeId родительской заявки (кнопки Сервис/Монтаж в дереве). */
	parentPrefillInitTypeId: number = null;

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		protected appService: AppService,
		protected notificationService: NotificationService,
		protected dataService: NewRequestsService,
		private customerObjectsService: CustomerObjectsService,
		private contragentsService: ContragentsService,
		private leadsService: LeadsService,
		private requestsService: RequestsService,
		private dadataService: DaDataService,
		private changeDetectorRef: ChangeDetectorRef,
		protected dialogService: DialogService
	) {
		super(route, router, appService, notificationService, dataService);
		this.listPageRoutePath = 'requests';
		this.appService.pageTitle = 'Новая заявка';
	}

	ngOnInit() {
		this.canEditForm = true;
		this.isNew = true;
		this.entityViewModel = new EntityViewModel<NewRequest>();
		this.entityViewModel.entity = new NewRequest();
		this.entityViewModel.entity.warehouseId = 0;

		const leadIdParam = this.route.snapshot.queryParamMap.get('leadId');
		const parentRequestIdParam = this.route.snapshot.queryParamMap.get('parentRequestId');
		const requestTypeIdParam = this.route.snapshot.queryParamMap.get('requestTypeId');

		// parent-контекст (кнопки дерева) имеет приоритет над leadId для этапа 1
		if (parentRequestIdParam) {
			const parentId = parseInt(parentRequestIdParam, 10);
			const requestTypeId = requestTypeIdParam ? parseInt(requestTypeIdParam, 10) : NaN;
			if (!isNaN(parentId) && parentId > 0) {
				this.parentContextId = parentId;
				this.loadParentAndPrefillForm(parentId, !isNaN(requestTypeId) && requestTypeId > 0 ? requestTypeId : null);
			}
		} else if (leadIdParam) {
			const parsed = parseInt(leadIdParam, 10);
			if (!isNaN(parsed) && parsed > 0) {
				this.leadContextId = parsed;
				this.loadLeadAndPrefillForm(parsed);
			}
		}

		window.addEventListener('scroll', () => {
			const element = document.querySelector('.your-element') as HTMLElement | null;
			const scrollPosition = window.scrollY || window.pageYOffset;
			const threshold = 61;
			
			if (element) {
				if (scrollPosition > threshold) {
					element.style.position = 'fixed';
					element.style.top = '75px';
				} else {
					element.style.position = 'static';
				}
			}
		});
	}

	beforeSaveChanges(): void {
		if (this.leadContextId != null) {
			this.entityViewModel.entity.leadId = this.leadContextId;
			this.entityViewModel.entity.initType = this.leadPrefillInitTypeId != null
				? this.leadPrefillInitTypeId
				: 2;
		}
		if (this.parentContextId != null) {
			this.entityViewModel.entity.parentRequestId = this.parentContextId;
			if (this.parentPrefillInitTypeId != null) {
				this.entityViewModel.entity.initType = this.parentPrefillInitTypeId;
			}
		}
		if (!this.isReclamation && this.parentContextId == null) {
			this.entityViewModel.entity.parentRequestId = null;
			this.entityViewModel.entity.requestDevices.forEach(x => {
				x.installTypeId = null;
				x.marketPlaceId = null;
				x.inReclamation = false;
			});
		}
	}

	afterSaveChanges() {
		if (!this.entityId)
			return;

		if (this.leadContextId != null) {
			const payload = {
				leadId: this.leadContextId,
				requestId: this.entityId,
				updatedAtUtc: new Date().toISOString()
			};
			localStorage.setItem(this.leadUpdatedStorageEventKey, JSON.stringify(payload));
		}

		this.router.navigate(['/requests/', this.entityId]);
	}

	saveContragent(contragent: ContragentWithContactDto) {
		if (contragent == null) {
			this.customerObjectInfoBlock.customerObjectChange(null);
			this.entityViewModel.entity.customerContragentId = null;
			this.entityViewModel.entity.customerObjectId = null;
		}
		else {
			if (this.entityViewModel.entity.customerContragentId != contragent.id) {
				this.customerObjectInfoBlock.customerObjectChange(null);
				this.entityViewModel.entity.customerObjectId = null;
			}
			this.entityViewModel.entity.customerContragentId = contragent.id;
			this.loadCustomerObjects();
		}

		this.checkCustomerObjectDevices();
	}

	customerObjectChange(customerObjectId: number) {
		if (customerObjectId == null || customerObjectId === undefined) {
			this.saveCustomerObject(null);
			return;
		}
		this.customerObjectsService.getCustomerObjectWithContacts(customerObjectId).subscribe(co => {
			this.saveCustomerObject(co);
		});
	}

	saveCustomerObject(customerObject: CustomerObjectWithContactsDto) {
		this.selectedCustomerObject = customerObject;
		if (customerObject) {
			this.customerObjectsService.getCustomerObjectsByContragent(this.entityViewModel.entity.customerContragentId)
				.subscribe((resp) => {
					this.customerObjects = resp;
					this.entityViewModel.entity.customerObjectId = customerObject.customerObjectId;
					this.checkCustomerObjectDevices();
				});
		}
		else {
			this.entityViewModel.entity.customerObjectId = null;
			this.checkCustomerObjectDevices();
		}
	}

	saveServiceCenter(serviceCenterId: number) {
		this.entityViewModel.entity.serviceCenterId = serviceCenterId;
	}

	loadCustomerObjects() {
		this.customerObjectsService.getCustomerObjectsByContragent(this.entityViewModel.entity.customerContragentId)
			.subscribe((resp) => {
				this.customerObjects = resp;
				const objectIdToSelect = this.pendingCustomerObjectId
					|| (resp.length == 1 ? resp[0].id : null);
				this.pendingCustomerObjectId = null;
				if (objectIdToSelect && this.customerObjectInfoBlock) {
					this.customerObjectInfoBlock.customerObjectChange(objectIdToSelect);
				}
			});
	}

	changeRequestTypeId(requestTypeId: number) {
		this.entityViewModel.entity.requestTypeId = requestTypeId;
		this.notifyChangeRequestGeneralData();
		this.checkCustomerObjectDevices();
	}

	changeRequestCategoryId(requestCategoryId: number) {
		this.entityViewModel.entity.requestCategoryId = requestCategoryId;
		this.notifyChangeRequestGeneralData();
	}

	notifyChangeRequestGeneralData() {
		this.servicesAndDevicesBlock.changeRequestTypeAndCategory(
			this.entityViewModel.entity.requestTypeId, this.entityViewModel.entity.requestCategoryId);
	}

	checkCustomerObjectDevices() {
		const customerObjectId = this.entityViewModel.entity.customerObjectId;
		const shouldLoadObjectDevices = (this.isReclamation || this.isService) && customerObjectId;

		if (shouldLoadObjectDevices) {
			this.customerObjectsService.getCustomerObjectDevices(customerObjectId).subscribe(resp => {
				this.servicesAndDevicesBlock.setCustomerObjectDevices(resp);
			});
			if (this.isReclamation && this.relatedRequestsBlock) {
				this.relatedRequestsBlock.loadData(customerObjectId);
			}
		}
		else {
			if (this.isReclamation && this.relatedRequestsBlock) {
				this.relatedRequestsBlock.loadData(customerObjectId);
			}

			if (this.servicesAndDevicesBlock) {
				this.servicesAndDevicesBlock.setCustomerObjectDevices([]);
			}
		}
	}

	changeRequestDescription(requestDescription: string) {
		this.entityViewModel.entity.description = requestDescription;
	}

	changeResponsibleUserId(responsibleUserId: number) {
		this.entityViewModel.entity.responsibleUserId = responsibleUserId;
	}

	saveRequestServices(requestServices: NewRequestService[] = []) {
		this.entityViewModel.entity.requestServices = requestServices;
	}

	saveRequestDevices(requestDevices: NewRequestDevice[] = []) {
		this.entityViewModel.entity.requestDevices = requestDevices;
	}

	saveRequestReclamationDeviceId(reclamationDeviceId: number) {
		this.entityViewModel.entity.reclamationDeviceId = reclamationDeviceId;
	}

	changeCostCenterId(event: { costCenterId: number, confirm: boolean }) {
		const applyCostCenter = () => {
			this.entityViewModel.entity.costCenterId = event.costCenterId;
			if (this.servicesAndDevicesBlock) {
				this.servicesAndDevicesBlock.setCostCenter(event.costCenterId);
			}
		};

		if (!this.servicesAndDevicesBlock || !event.confirm) {
			applyCostCenter();
			return;
		}

		let fullCostCenters = this.servicesAndDevicesBlock.fullCostCenters;
		let costCenter0 = fullCostCenters.find(x => x.code == '0');
		let costCenter0Id = costCenter0 != null ? costCenter0.costCenterId : null;
		let currentCostCenter = fullCostCenters.find(x => x.costCenterId == event.costCenterId);
		let currentCostCenterName = currentCostCenter == null 
			? 'Не указан'
			: `${currentCostCenter.code} ${currentCostCenter.name}`;
		let serviceOrDevicesHasCostCenter = 
			this.entityViewModel.entity.requestServices.some(x => x.costCenterId != null && x.costCenterId != costCenter0Id) ||
			this.entityViewModel.entity.requestDevices.some(x => x.costCenterId != null && x.costCenterId != costCenter0Id);

		if (serviceOrDevicesHasCostCenter) {
			this.notificationService.confirmation({
				title: "Смена кост-центра",
				message: `В услугах и оборудовании будет изменен кост-центр на ${currentCostCenterName}. Продолжить?`,
				type: 'question',
				confirmButtonText: 'Сохранить',
				cancelButtonText: 'Отмена',
				showCloseButton: false,
			}, () => {
				applyCostCenter();
			}, () => {
				return;
			});
		}
		else {
			applyCostCenter();
		}
	}

	changeRelatedRequestId(requestId) {
		this.entityViewModel.entity.parentRequestId = requestId;
	}

	onMouseEnter(index: number) {
		this.menuComponent.changeState(index, true);
	}

	onMouseLeave(index: number) {
		// чтобы отображался активным последний
		//this.menuComponent.changeState(index, false);
	}

	scrollToElement(index: number) {
		const elementId = `navCard${index}`;
		const element = document.getElementById(elementId);
		if (element) {
			const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    		const offsetPosition = elementPosition - 150;
			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth'
			});
		}
  	}

	get menuItemStates(): MenuItemState[] {
		let states = [{
			index: NewRequestMenuItemsEnum.clientInfo,
			isError: this.entityViewModel.entity.customerContragentId == null, 
			isDefault: false
		}, {
			index: NewRequestMenuItemsEnum.requestInfo,
			isError: !(this.descriptionIsValid || (this.isLaboratory && this.entityViewModel.entity.requestCategoryId != null)),
			isDefault: false
		}, {
			index: NewRequestMenuItemsEnum.servicesAndDevices,
			isError: this.servicesAndDevicesBlock != null && !this.servicesAndDevicesBlock.costCentersCompleted,
			isDefault: this.entityViewModel.entity.requestDevices.length == 0 && this.entityViewModel.entity.requestServices.length == 0
		}, {
			index: NewRequestMenuItemsEnum.customerObjectInfo,
			isError: this.isLaboratory 
				? this.entityViewModel.entity.serviceCenterId == null || this.entityViewModel.entity.serviceCenterId == null
				: false,
			isDefault: this.entityViewModel.entity.customerObjectId == null || this.entityViewModel.entity.serviceCenterId == null 
		}, {
			index: NewRequestMenuItemsEnum.contacts,
			isError: false,
			isDefault: this.entityViewModel.entity.customerObjectId == null
		}, {
			index: NewRequestMenuItemsEnum.clientRequestHistory,
			isError: false,
			isDefault: false
		}];

		return states;
	}

	get editRequestServicesDisabled(): boolean {
		return this.entityViewModel.entity.requestTypeId == null
			|| this.entityViewModel.entity.requestTypeId == 0
			|| this.entityViewModel.entity.requestCategoryId == null
			|| this.entityViewModel.entity.requestCategoryId == 0;
	}

	get createRequestAvailable(): boolean {
		switch (true) {
			case this.isLaboratory:
				return this.entityViewModel.entity.customerContragentId != null &&
					this.entityViewModel.entity.requestCategoryId != null &&
					this.entityViewModel.entity.customerObjectId != null &&
					this.menuItemStates.every(x => !x.isError);
			case this.isPersonalWarehouseReplenishment:
				return this.entityViewModel.entity.customerContragentId != null &&
					this.entityViewModel.entity.customerObjectId != null &&
					this.descriptionIsValid &&
					this.menuItemStates.every(x => !x.isError);
			default:
				return this.menuItemStates.every(x => !x.isError);
					//this.entityViewModel.entity.customerContragentId != null && this.descriptionIsValid;
		}
	}

	get descriptionIsValid(): boolean {
		return this.entityViewModel.entity.description != null &&
			this.entityViewModel.entity.description.trim() != '';
	}

	get isReclamation(): boolean {
		return this.entityViewModel.entity.requestTypeId == <number>RequestType.reclamation;
	}

	get isService(): boolean {
		return this.entityViewModel.entity.requestTypeId == <number>RequestType.service;
	}

	get isLaboratory(): boolean {
		return this.entityViewModel.entity.requestTypeId == <number>RequestType.laboratory;
	}

	get showRequestServicesAndDevices(): boolean {
		return !this.isPersonalWarehouseReplenishment && !this.isServiceAgreement;
	}

	get isPersonalWarehouseReplenishment(): boolean {
		return this.entityViewModel.entity.requestTypeId == <number>RequestType.personalWarehouseReplenishment;
	}

	get isServiceAgreement(): boolean {
		return this.entityViewModel.entity.requestTypeId == <number>RequestType.serviceAgreement;
	}

	get isCustomerObjectRequired(): boolean {
		return this.isLaboratory || this.isPersonalWarehouseReplenishment;
	}

	private loadLeadAndPrefillForm(leadId: number): void {
		this.leadsService.getLeadById(leadId).subscribe(
			lead => this.applyLeadDetailsToForm(lead),
			() => { this.leadDetailsLoaded = true; }
		);
	}

	private loadParentAndPrefillForm(parentRequestId: number, requestTypeId: number): void {
		// getBwtById — тот же источник, что карточка заявки; там есть requestCategoryId / клиент / объект
		this.requestsService.getBwtById(parentRequestId).subscribe(
			vm => this.applyParentRequestToForm(vm.entity, requestTypeId),
			() => { this.leadDetailsLoaded = true; }
		);
	}

	/**
	 * Prefill с родительской заявки — тот же паттерн, что applyLeadDetailsToForm:
	 * тип/категория/филиал + контрагент/объект через существующие пути.
	 */
	private applyParentRequestToForm(parent: RequestBwt, requestTypeId: number): void {
		this.entityViewModel.entity.parentRequestId = parent.requestId;

		if (parent.initTypeId != null && parent.initTypeId > 0) {
			this.parentPrefillInitTypeId = parent.initTypeId;
			this.entityViewModel.entity.initType = parent.initTypeId;
			this.entityViewModel.entity.initTypeId = parent.initTypeId;
		}

		if (requestTypeId != null) {
			this.entityViewModel.entity.requestTypeId = requestTypeId;
		}

		if (parent.requestCategoryId != null && parent.requestCategoryId !== 0) {
			this.entityViewModel.entity.requestCategoryId = parent.requestCategoryId;
		} else {
			// INBWT-908: если у родителя категории нет — поле не заполняется
			this.entityViewModel.entity.requestCategoryId = null;
		}

		if (parent.serviceCenterId != null) {
			this.entityViewModel.entity.serviceCenterId = parent.serviceCenterId;
		}

		this.applyConsultationChildDescription(parent, requestTypeId);

		this.applySourceContragentAndObject(parent.customerContragentId, parent.customerObjectId);
	}

	/** INBWT-925: описание дочерней заявки из «Консультация». */
	private applyConsultationChildDescription(parent: RequestBwt, requestTypeId: number): void {
		if (parent.requestTypeId !== RequestType.consultation || requestTypeId == null) {
			return;
		}

		const parentNumber = parent.requestId;
		if (requestTypeId === RequestType.service) {
			this.entityViewModel.entity.description = `Выезд для забора проб и обследования по заявке Консультация ${parentNumber}`;
		} else if (requestTypeId === RequestType.install) {
			this.entityViewModel.entity.description = `Монтаж по заявке Консультация ${parentNumber}`;
		}
	}

	private applyLeadDetailsToForm(lead: LeadDetails): void {
		if (lead.description && lead.description.trim()) {
			this.entityViewModel.entity.description = lead.description.trim();
		}

		if (lead.initTypeId != null) {
			this.leadPrefillInitTypeId = lead.initTypeId;
			this.entityViewModel.entity.initType = lead.initTypeId;
			this.entityViewModel.entity.initTypeId = lead.initTypeId;
		}

		if (lead.serviceCenterId != null) {
			this.entityViewModel.entity.serviceCenterId = lead.serviceCenterId;
		}

		if (lead.defaultRequestTypeId != null) {
			this.entityViewModel.entity.requestTypeId = lead.defaultRequestTypeId;
		}

		if (lead.defaultRequestCategoryId != null) {
			this.entityViewModel.entity.requestCategoryId = lead.defaultRequestCategoryId;
		}

		this.leadDetailsLoaded = true;

		if (lead.contragentId) {
			this.applySourceContragentAndObject(lead.contragentId, null);
		} else {
			this.buildLeadNewClientPrefill(lead);
		}
	}

	/** Общее применение контрагента/объекта на форму (lead и parent). */
	private applySourceContragentAndObject(contragentId: number, customerObjectId: number): void {
		this.leadDetailsLoaded = true;

		if (!contragentId) {
			return;
		}

		// Выбор в дропдауне делает customerObjectInfoBlock (как при одном объекте у клиента).
		// Вызов page.customerObjectChange обновляет только модель страницы, без ngModel дропдауна.
		this.pendingCustomerObjectId = customerObjectId > 0 ? customerObjectId : null;

		this.contragentsService.getContragentWithContact(contragentId).subscribe(c => {
			setTimeout(() => {
				if (this.clientInfoComponent) {
					this.clientInfoComponent.applyContragentFromExternal(c);
				}
				this.saveContragent(c);
			});
		});
	}

	private buildLeadNewClientPrefill(lead: LeadDetails): void {
		const name = (lead.customerName || '').trim();
		const parts = name ? name.split(/\s+/).filter(p => p.length > 0) : [];
		const phoneDigits = (lead.customerPhone || '').replace(/\D/g, '');

		const base: Partial<ContragentWithContactDto> = {
			isIndividual: true,
			contactLastName: parts[0] || '',
			contactFirstName: parts[1] || '',
			contactMiddleName: parts[2] || '',
			contactEmail: (lead.customerEmail || '').trim(),
			contactPhone: phoneDigits || '',
		};

		const addr = (lead.customerAddress || '').trim();
		if (!addr) {
			this.leadNewClientPrefill = base;
			this.changeDetectorRef.detectChanges();
			this.clientInfoComponent.openCreateContragentDialog();
			return;
		}

		this.dadataService.suggest(addr).subscribe(suggestions => {
			if (suggestions && suggestions.length > 0) {
				base.address = suggestions[0].address;
			} else {
				base.address = lead.customerAddress;
			}
			this.leadNewClientPrefill = base;
			this.changeDetectorRef.detectChanges();
			this.clientInfoComponent.openCreateContragentDialog();
		});
	}
}
